import React from 'react';
import './Location.css';

const Location = () => {
  return (
    <>
    {/* // For Maps */}
    <div className="location">
    <iframe style={{width:'100%', height:'500px'}} title ="location Website" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.5941181644635!2d77.22218287473763!3d28.641924383655578!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd16a948d3fb%3A0x6e71b8c5e219577e!2sGKM%20POWER%20PROJECTS%20PVT%20LTD!5e0!3m2!1shi!2sin!4v1713771232458!5m2!1shi!2sin"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
    </>

  )
}

export default Location
